import HigherOrderStepData from "higherorder/HigherOrderStepData.js";
import Macroable from './Macroable.js';
import ParamSavable from "effects/midi/mappable/ParamSavable.js";
import ParamDisableable from "effects/midi/mappable/ParamDisableable.js";
import Paramable from './Paramable.js';
import Shapeable from "higherorder/Shapeable.js";
import Registered from "utils/Registered.js";
import Dispatchable from "utils/Dispatchable.js";
import Savable from './Savable.js';
import Editable from './Editable.js';
import Graphical from './Graphical.js';
import Algorithmic from './Algorithmic.js';
import Scriptable from './Scriptable.js';
import Routable from './Routable.js';
import {compose} from "utils/compose.js";

export default class HigherOrderSequencer extends
compose(
    Graphical,
    ParamDisableable,
    Algorithmic,
    Editable,
    ParamSavable,
    Savable,
    Routable,
    Dispatchable,
    Shapeable,
    Paramable,
    Registered,
    Scriptable,
    Macroable
)(class {}) {
    constructor(sequencerEngine) {
        super();
        this.sequencerEngine = sequencerEngine;
        this.matrix = new Array(16).fill(
            []);
        this.steps = [];
        for (let i=0; i < 16; i++) {
            this.matrix[i] = new Array(10).fill(0);
        }

        this.initScripting();
        this.initDisabledParameters();
        this.initAutomation();
    }

    stop() {
        this.wasRolling = false;
        this.currentAlgorithms = {};
    }

}

